export const reactReduxToastrOptions = (
    position = "top-right",
    timeOut = 7000,
    component = null
) => {
    const options = {
        position: position,
        timeOut: timeOut,
        component: component
    };
    return options;
};

export const _sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const executeScroll = (size = 0) => window.scrollTo({ top: size, behavior: "smooth" });

export const statusColor = (status) => {
    switch (parseInt(status)) {
        case 0:
            return "progress-c-theme3";
        case 1:
            return "progress-c-theme";
        case 2:
            return "progress-c-theme4";
        case 3:
            return "progress-c-theme4";
        default:
            return null;
    }
};
